import { manager } from 'socket-resources/socket-manager/index'

const createSocketConnection = (connectionUrl, authToken) => {
  const ioConnection = manager.socket(connectionUrl, {
    ...(authToken
      ? {
          auth: {
            authorization: `Bearer ${authToken}`
          }
        }
      : {})
  })

  return ioConnection
}

export default createSocketConnection
